import React from "react";

import SrrRowBase from "./SrrRowBase";

const ReportNSByConsultant = ({ row }) => {
  const lastItem = {
    soldCars: 0,
    soldCarsToNewClients: 0,
    percentNewClients: 0,
    soldCarsToLoyalClients: 0,
    soldCarsToLoyalClientsMoney: 0,
    percentLoyalClients: 0,
    twoCars: 0,
    percentTwoCars: 0,
    threeCars: 0,
    percentThreeCars: 0,
    fourOrMoreCars: 0,
    percentFourOrMoreCars: 0,
  };

  const renderItem = [
    row.dealer.DealerName,
    row.consultant,

    ...row.periodsData
      .map((el) => {
        lastItem.soldCars += el.soldCars;
        lastItem.soldCarsToNewClients += el.soldCarsToNewClients;
        lastItem.percentNewClients += el.percentNewClients;
        lastItem.soldCarsToLoyalClients += el.soldCarsToLoyalClients;
        lastItem.soldCarsToLoyalClientsMoney += el.soldCarsToLoyalClientsMoney;
        lastItem.percentLoyalClients += el.percentLoyalClients;
        lastItem.twoCars += el.twoCars;
        lastItem.percentTwoCars += el.percentTwoCars;
        lastItem.threeCars += el.threeCars;
        lastItem.percentThreeCars += el.percentThreeCars;
        lastItem.fourOrMoreCars += el.fourOrMoreCars;
        lastItem.percentFourOrMoreCars += el.percentFourOrMoreCars;

        return [
          el.soldCars,
          el.soldCarsToNewClients,
          el.percentNewClients,
          el.soldCarsToLoyalClients,
          el.soldCarsToLoyalClientsMoney,
          el.percentLoyalClients,
          el.twoCars,
          el.percentTwoCars,
          el.threeCars,
          el.percentThreeCars,
          el.fourOrMoreCars,
          el.percentFourOrMoreCars,
        ];
      })
      .flat(),
    lastItem.soldCars,
    lastItem.soldCarsToNewClients,
    lastItem.percentNewClients,
    lastItem.soldCarsToLoyalClients,
    lastItem.soldCarsToLoyalClientsMoney,
    lastItem.percentLoyalClients,
    lastItem.twoCars,
    lastItem.percentTwoCars,
    lastItem.threeCars,
    lastItem.percentThreeCars,
    lastItem.fourOrMoreCars,
    lastItem.percentFourOrMoreCars,
  ];

  return <SrrRowBase cells={renderItem} />;
};

export default ReportNSByConsultant;
